// Website visibility courtesy for Shifter. Direct API/object access is accepted;
// this is not an authorization rule and must not stop private transcription.
export const blockedPodcastIds = ["cd9d99fd-b8dd-4160-859b-35c9e89938d8"];
